import script from "./updatePasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./updatePasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./updatePasswordForm.vue?vue&type=style&index=0&id=bcead840&lang=css"

const __exports__ = script;

export default __exports__